import { matchAcronyms } from '../../logic/utils/utils';

export async function getFieldAllocation(field: string) {
    // do something else if localhost (local testing)
    if (window.location.host === 'localhost:3000') {
        return new Response(field === 'left' ? matchAcronyms[0] : matchAcronyms[6]);
    }
    const response = await fetch('https://bct-scoreboard-v2.taegener.eu/web/access/get_field_allocation.php', {
        mode: 'cors',
        method: 'POST',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8',
        },
        body: JSON.stringify({ field: field }),
    });
    if (!response.ok) {
        throw new Error(`[FieldController.ts] Error getting field content. HTTP status: ${response.status}`);
    }
    console.info(`[FieldController.ts] Retrieving field content: ${response}}`);
    return response;
}
